/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentSecondBuyerStep_root$ref: FragmentReference;
declare export opaque type DevelopmentSecondBuyerStep_root$fragmentType: DevelopmentSecondBuyerStep_root$ref;
export type DevelopmentSecondBuyerStep_root = {|
  +workPermitTypes: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +label: string,
  |}>,
  +occupationTypes: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +label: string,
  |}>,
  +nationalityTypes: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +label: string,
  |}>,
  +$refType: DevelopmentSecondBuyerStep_root$ref,
|};
export type DevelopmentSecondBuyerStep_root$data = DevelopmentSecondBuyerStep_root;
export type DevelopmentSecondBuyerStep_root$key = {
  +$data?: DevelopmentSecondBuyerStep_root$data,
  +$fragmentRefs: DevelopmentSecondBuyerStep_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentSecondBuyerStep_root",
  "selections": [
    {
      "alias": "workPermitTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "work_permit_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": "dictionaries(type:\"work_permit_types\")"
    },
    {
      "alias": "occupationTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "occupation_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": "dictionaries(type:\"occupation_types\")"
    },
    {
      "alias": "nationalityTypes",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "nationality_types"
        }
      ],
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "dictionaries",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": "dictionaries(type:\"nationality_types\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '65c0ef27eec8f8d0cf984ca707c19f50';

export default node;
